import api from '@/api/Api';
import { WidgetResponse } from '@/api/services/widgetService';

export const widgetApi = {
  getWidgetTheme: async (): Promise<WidgetResponse> => {
    try {
      const response = await api.get('/widgets');

      console.log('Got widget theme response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching widget configuration:', error);
      throw error;
    }
  },

  updateWidgetTheme: async (theme: any): Promise<WidgetResponse> => {
    try {
      const response = await api.patch(`/widgets`, {
        widgetTheme: theme
      });

      console.log('Widget theme update API response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error updating widget theme:', error);
      throw error;
    }
  }
};